// Libraries
var React = require('react');
var $ = require('jquery');
var ReactHeatmap = require('../../../common/ReactHeatmap/ReactHeatmap');

// Styles
require('./LineupPlayer.scss');

// Components
var DefenderLineupStats = require('./DefenderLineupStats');
var MidfielderLineupStats = require('./MidfielderLineupStats');
var StrikerLineupStats = require('./StrikerLineupStats');
var GoalkeeperLineupStats = require('./GoalkeeperLineupStats');

// Assets
var spinner = require('images/Rolling.svg');

const highlightTypes = {
	None: 'None',
	Goal: 'Goal',
	Assist: 'Assist',
	Penalty: 'Penalty',
	YellowCard: 'YellowCard',
	RedCard: 'RedCard',
	YellowRedCard: 'YellowRedCard',
	SubstitutionOff: 'SubstitutionOff',
	SubstitutionOn: 'SubstitutionOn',
	PenaltyShotScored: 'PenaltyShotScored',
	PenaltyShotSaved: 'PenaltyShotSaved'
};

class LineupPlayerModule extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			isOpen: false,
			isLoading: true,
			heatmapData: null,
			allStats: {},
			highlights: props.highlights
		};
	}

	componentWillReceiveProps(props) {
		this.setState({
			highlights: props.highlights
		});
	}

	handleOnClick = (event) => {
		let enterPressed = event.type === 'keypress' && event.key === 'Enter';
		let isOpen = this.state.isOpen;

		if (enterPressed || event.type === 'click') {
			// toggle content
			this.setState({ isOpen: !this.state.isOpen });
			if (!isOpen) {
				this.getStats();
				this.statsPoll = setInterval(() => {
					this.getStats(false, false);
				}, 30000);
				this.playerStats.setAttribute('tabIndex', '0');
			} else {
				this.playerStats.setAttribute('tabIndex', '-1');
				this.playerStats.previousSibling.focus();
				clearInterval(this.statsPoll);
			}
		} else if (event.key === 'Escape' && isOpen) {
			this.playerStats.setAttribute('tabIndex', '-1');
			this.playerStats.previousSibling.focus();
			this.setState({ isOpen: !this.state.isOpen });
			clearInterval(this.statsPoll);
		}
	};

	handleKeyDown = (event) => {
		if (event.key === 'Escape') {
			this.playerStats.setAttribute('tabIndex', '-1');
			this.playerStats.previousSibling.focus();
			this.setState({ isOpen: !this.state.isOpen });
			clearInterval(this.statsPoll);
		}
	}

	getStats = (showSpinner = true, focusElement = true) => {
		if (showSpinner) this.setState({ isLoading: true });

		$.ajax({
			method: "GET",
			url: this.props.player.statsUrl
		})
			.done(data => {
				let transformedData = []
				if (data.Stats.Heatmap.length > 0) {
					transformedData = data.Stats.Heatmap.map((item) => {
						return {
							'x': Math.round(item.X),
							'y': 100 - item.Y
						};
					});
				}
				this.setState({ heatmapData: transformedData, isLoading: false, allStats: data },
					() => {
						if (focusElement) this.playerStats.focus();
					});
			})
			.fail(() => {
				this.setState({ isLoading: false });
			});
	}

	getPlayerHighlights = (highlights, playerId) => {
		let hlArray = [];
		if (highlights) {
			for (let i = 0; i < highlights.length; i++) {
				if ((highlights[i].Player && highlights[i].Player.PlayerId === playerId) ||
					(highlights[i].PlayerOn && highlights[i].PlayerOn.PlayerId === playerId) ||
					(highlights[i].Assist && highlights[i].Assist.PlayerId === playerId)) {
					hlArray.push(highlights[i]);
				}
			}
		}
		return hlArray;
	}

	getHighlightType(currentHighlight, playerId) {
		switch (currentHighlight.HighlightType) {
			case "Goal":
				switch (currentHighlight.GoalTypeName) {
					case "Goal":
						if (currentHighlight.Player && currentHighlight.Player.PlayerId === playerId) {
							return highlightTypes.Goal;
						}
						if (currentHighlight.Assist && currentHighlight.Assist.PlayerId === playerId) {
							return highlightTypes.Assist;
						}
						break;
					case "Penalty":
						return highlightTypes.Penalty;
					default:
						break;
				}
				return highlightTypes.None;
			case "Booking":
				switch (currentHighlight.CardType) {
					case "YellowCard":
						return highlightTypes.YellowCard;
					case "YellowRedCard":
						return highlightTypes.YellowRedCard;
					case "RedCard":
						return highlightTypes.RedCard;
					default:
						break;
				}
			case "Substitution":
				if (currentHighlight.Player && currentHighlight.Player.PlayerId === playerId) {
					return highlightTypes.SubstitutionOff;
				}
				if (currentHighlight.PlayerOn && currentHighlight.PlayerOn.PlayerId === playerId) {
					return highlightTypes.SubstitutionOn;
				}
				break;
			/* penalties in a shootout do not appear in the line-up
			case "PenaltyShot":
				switch (currentHighlight.Outcome) {
					case "Scored":
						return  highlightTypes.PenaltyShotScored;
					case "Saved":
						return highlightTypes.PenaltyShotSaved;
					default:
						return highlightTypes.None;
				}
			*/
			default:
				break;
		}
		return highlightTypes.None;
	}

	renderHighlightIcon(highlightType) {
		switch (highlightType) {
			case highlightTypes.None:
				return '';
			case highlightTypes.Goal:
			case highlightTypes.Penalty:
				return (<span className="event event__goal"></span>);
			case highlightTypes.Assist:
				return (<span className="event event__assist"></span>);
			case highlightTypes.YellowCard:
				return (<span className="event event__yellowcard"></span>);
			case highlightTypes.RedCard:
				return (<span className="event event__redcard"></span>);
			case highlightTypes.YellowRedCard:
				return (<span className="event event__yellowredcard"></span>);
			case highlightTypes.SubstitutionOff:
				return (<span className="event event__substitution_out"></span>);
			case highlightTypes.SubstitutionOn:
				return (<span className="event event__substitution_in"></span>);
			case highlightTypes.PenaltyShotScored:
				return (<span><span className="event event__goal"></span>(P)</span>);
			case highlightTypes.PenaltyShotSaved:
				return (<span><span className="event event__goal_saved"></span>(P)</span>);
			default:
				return '';
		}
	}

	highlightTypesAreEffectivelyTheSame(typeA, typeB) {

		if (typeA === typeB) {
			return true;
		}

		if (
			(typeA === highlightTypes.Goal || typeA === highlightTypes.Penalty) &&
			(typeB === highlightTypes.Goal || typeB === highlightTypes.Penalty)
		) {
			return true;
		}

		return false;
	}

	renderPlayerHighlights(highlights, playerId) {
		const playerHighlights = this.getPlayerHighlights(highlights, playerId);
		const playerHighlightsType = playerHighlights.map(x => this.getHighlightType(x, playerId));

		return playerHighlights.map((item, index) => {
			const highlightType = playerHighlightsType[index];
			if (highlightType === highlightTypes.None)
				return '';

			let minute = item.MatchMinute && item.MatchMinute !== "PEN"
				? item.MatchMinute
				: item.Minute;

			if (index > 0 && this.highlightTypesAreEffectivelyTheSame(playerHighlightsType[index], playerHighlightsType[index - 1])) {
				return (<React.Fragment key={index}>, {minute}'{highlightType === highlightTypes.Penalty ? ' (P)' : ''}</React.Fragment>)
			}

			return (<React.Fragment key={index}>
				{this.renderHighlightIcon(highlightType)}{minute}'{highlightType === highlightTypes.Penalty ? ' (P)' : ''}
				</React.Fragment>)
		});
	}

	render() {
		let noData = !this.state.allStats.Position && !this.state.allStats.Age && (this.state.heatmapData === null || this.state.heatmapData.length === 0);
		const highlights = this.renderPlayerHighlights(this.state.highlights, this.props.player.PlayerId);

		return (
			<div className="LineupPlayer">
				<div className={"LineupPlayer__header" + (this.state.isOpen ? " open" : "")} onClick={this.handleOnClick} onKeyPress={this.handleOnClick} tabIndex="0" aria-label={this.props.player.Name} aria-haspopup aria-expanded={this.state.isOpen ? true : false} role="button">
					<div>
						<span className="LineupPlayer__header--position">{this.props.player.Number.toString().length === 1 ? ("0" + this.props.player.Number) : this.props.player.Number}</span>
						<span className="LineupPlayer__header--name">{this.props.player.Name}</span>
						<span className="event__highlights">{highlights}</span>
					</div>
				</div>
				<div className={"LineupPlayer__content" + (this.state.isOpen ? " open" : "")} onKeyDown={this.handleKeyDown} ref={(playerStats) => { this.playerStats = playerStats; }}>
					{this.state.isLoading ? <img src={spinner} className="spinner" alt="Loading..." /> :
						<div>
							{this.state.allStats.Position &&
								<p className="LineupPlayer__info"><span>Position:</span> {this.state.allStats.Position}</p>
							}

							{this.state.allStats.Age &&
								<p className="LineupPlayer__info"><span>Age:</span> {this.state.allStats.Age}</p>
							}

							{this.state.heatmapData !== null && this.state.heatmapData.length > 0 &&
								<div className="LineupPlayer__heatmap" ref={(heatmap) => { this.heatmap = heatmap; }}>
									<ReactHeatmap max={5} data={this.state.heatmapData} unit="percent" />
								</div>
							}

							{this.state.heatmapData !== null && this.state.heatmapData.length > 0 &&
								<div className="LineupPlayer__labels">
									<span className="LineupPlayer__labels--left">Defending</span>
									<span className="LineupPlayer__labels--right">Attacking</span>
								</div>
							}

							{this.state.allStats && this.state.allStats.Position === "Defender" &&
								<DefenderLineupStats {...this.state.allStats.Stats} />
							}

							{this.state.allStats && this.state.allStats.Position === "Goalkeeper" &&
								<GoalkeeperLineupStats {...this.state.allStats.Stats} />
							}

							{this.state.allStats && this.state.allStats.Position === "Midfielder" &&
								<MidfielderLineupStats {...this.state.allStats.Stats} />
							}

							{this.state.allStats && this.state.allStats.Position === "Forward" &&
								<StrikerLineupStats {...this.state.allStats.Stats} />
							}

							{noData &&
								<p className="LineupPlayer__error">No stats available</p>
							}
						</div>
					}
				</div>
			</div>
		)
	}
}

module.exports = LineupPlayerModule;



// WEBPACK FOOTER //
// ./src/components/MDC/Lineup/LineupPlayer.js